import { render, staticRenderFns } from "./TiposTurno.vue?vue&type=template&id=ff552e46&scoped=true"
import script from "./TiposTurno.vue?vue&type=script&lang=js"
export * from "./TiposTurno.vue?vue&type=script&lang=js"
import style0 from "./TiposTurno.vue?vue&type=style&index=0&id=ff552e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff552e46",
  null
  
)

export default component.exports